module.exports = __webpack_public_path__ + "assets/98cc35792acc8d9533e3a1153a42bce4.png";